export const MEETING = 'MEETING';
export const MOOD = 'MOOD';
export const NOTE = 'NOTE';



/** WEBPACK FOOTER **
 ** ./src/model/const.js
 **/